import { render } from "./TagsTable.vue?vue&type=template&id=d41f6008&scoped=true&lang=pug"
import script from "./TagsTable.vue?vue&type=script&lang=js"
export * from "./TagsTable.vue?vue&type=script&lang=js"

import "./TagsTable.vue?vue&type=style&index=0&id=d41f6008&lang=scss&scoped=true"
import "./TagsTable.vue?vue&type=style&index=1&id=d41f6008&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d41f6008"]])

export default __exports__